import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block text-xs text-medium" }

import { IonItem, IonIcon, IonLabel, modalController } from '@ionic/vue';
import { Voice } from '@/interfaces/voice';
import { playOutline, pauseOutline } from 'ionicons/icons';
import { useMedia } from '@/stores/media';
import { computed, ref, watch } from 'vue';
import { audioDurationString } from '@/utils';
import CustomButton from '@/components/CustomButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VoiceTalent',
  props: {
    voice: null
  },
  setup(__props: any) {

const props = __props as {
  voice: Voice;
}



const media = useMedia();

const confirm = (voice: Voice) => {
  media.filter.q = '';
  return modalController.dismiss(voice, 'confirm');
};

const playing = ref<boolean>(false);

const paused = ref<boolean>(false);

const duration = ref<number>(0);

const audio = new Audio(props.voice.file);

audio.addEventListener('loadedmetadata', () => {
  duration.value = audio.duration;
});

audio.addEventListener('playing', () => {
  paused.value = false;
  playing.value = true;
  media.audioStatus = 'PLAYING';
  media.current = props.voice;
});

audio.addEventListener('pause', () => {
  if (media.current?.id === props.voice.id) {
    paused.value = true;
    playing.value = false;
    media.audioStatus = 'PAUSED';
  } else {
    paused.value = false;
    playing.value = false;
    media.audioStatus = 'STOPPED';
  }
});

const play = () => {
  audio.play();
};

const pause = () => {
  audio.pause();
};

const stop = () => {
  pause();
  audio.currentTime = 0;
};

const icon = computed(() => {
  if (playing.value) return pauseOutline;
  return playOutline;
});

const talent = computed(() => props.voice);

const durationString = computed(() => audioDurationString(duration.value));

const current = computed(() => media.current);

const playPause = () => {
  if (playing.value) pause();
  else play();
};

watch(current, (value) => {
  const { voice } = props;
  if (value?.id !== voice.id) stop();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    key: _unref(talent).id,
    button: "",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (confirm(__props.voice)))
  }, {
    default: _withCtx(() => [
      _createVNode(CustomButton, {
        slot: "start",
        shape: "circle",
        fill: playing.value ? 'solid' : 'outline',
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (playPause()), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), { icon: _unref(icon) }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["fill"]),
      _createVNode(_unref(IonLabel), { class: "text-sm" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(talent).voice.name), 1),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(talent).language) + " - " + _toDisplayString(_unref(talent).accent), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLabel), {
        class: "text-xs",
        slot: "end"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(durationString)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})